module.exports = __webpack_public_path__ + "img/auriga.bac71d47.png";